export const FETCH_DEG = 'views/users/FETCH_DEG'
